import { WebAppPlatform, WebAppPlatforms } from "../WebAppPlatform";
import { AppCommandBinding } from "./AppCommandBinding";

export class AppCommandBindingEntry
{
  platformTypes:WebAppPlatform[] = [];
  bindings:AppCommandBinding[] = [];

  static forDesktop( binding:AppCommandBinding, ...bindings:AppCommandBinding[] )
  {
    let allBindings = [ binding ];

    if ( bindings )
    {
      allBindings = allBindings.concat( bindings );
    }

    return this.create( WebAppPlatforms.Desktop, allBindings );
  }

  static create( types:WebAppPlatform[], bindings:AppCommandBinding[] )
  {
    let entry = new AppCommandBindingEntry();
    
    entry.platformTypes = types;
    entry.bindings = bindings;

    return entry;
  }
}